import React, { useState, useRef, useEffect } from 'react';
import { SectionChart } from '@components';
import OrgGrid from './sectionWidget/OrgGrid';
import GanttGrid from './sectionWidget/GanttGrid';
import { Loading } from '@components';
import { v4 as uuidv4 } from 'uuid';
import { API } from '@service';

const WIDGET_GRID_MAP = {
  gantt: GanttGrid,
  org: OrgGrid,
};

const WedgitTemplate = ({ chartType = 'gantt' }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [data, setData] = useState([]);
  const originData = useRef({});

  const getChartTemplate = async () => {
    setIsLoading(true);
    const result = await API.getChartTemplate();

    result.forEach((e) => {
      if (e.chartType === chartType) {
        setData(JSON.parse(e.data));
        originData.current = e;
      }
    });
    setIsLoading(false);
  };

  const handleSave = async (data) => {
    if (JSON.stringify(data) === originData.current.data) {
      return;
    }

    setIsLoading(true);

    const requestData = originData.current;
    requestData.data = data;
    if (!requestData.id) {
      requestData.id = uuidv4();
      requestData.moduleId = '';
      requestData.moduleType = 'insights';
      requestData.chartType = chartType;
    }

    const saveResult = await API.saveChartTemplate(requestData);
    await getChartTemplate();
    setIsLoading(false);
  };

  useEffect(() => {
    getChartTemplate();
  }, []);

  const SectionGrid = WIDGET_GRID_MAP[chartType] || (() => null);
  const editTableRef = useRef(null);

  if (isLoading) {
    return (
      <div className="grid-display-switch-wrapper">
        <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
      </div>
    );
  }

  return (
    <>
      {!isEditMode ? (
        <>
          <SectionChart
            inputData={data}
            chartPattern={chartType}
            hasChartTitle={chartType === 'gantt'}
          />
        </>
      ) : null}
      <SectionGrid
        editTableRef={editTableRef}
        sourceData={data}
        handleSave={handleSave}
        toggleEdit={setIsEditMode}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default React.memo(WedgitTemplate);
